import React from 'react';
import {createRoot} from "react-dom/client";
import './styles/tokens.css';
import './styles/global.css';
import "@fontsource/mulish";
import { ThemeProvider } from './contexts/ThemeContext.jsx';
import { PortalVersionProvider } from './contexts/PortalVersionContext.jsx';
import App from './App.jsx';

const root = createRoot(document.getElementById("root"))
root.render(
    <PortalVersionProvider>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </PortalVersionProvider>
)
